export default {
  "api:admin:dashboard:branch:list": "api/admin/dashboard/branch-queue-summaries/",
}